import Page from '@/components/Page';
import { useTranslation } from 'react-i18next';
import serviceImage from '@/assets/images/stars.png';
import eclipseImage from '@/assets/images/eclipse.png';
import classes from './service.module.css';

const Service = () => {
  const { t } = useTranslation();
  return (
    <Page isFull>
      <div className={classes.content}>
        <div className={classes.right}>
          <div className={classes.textBox}>
            <div className={classes.title}>{t('pages.service.title')}</div>
            <div>{t('pages.service.paragraphs.first')}</div>
            <div>{t('pages.service.paragraphs.second')}</div>
            <div>{t('pages.service.paragraphs.third')}</div>
            <div>{t('pages.service.paragraphs.fourth')}</div>
          </div>
        </div>
        <div className={classes.left}>
          <div className={classes.astroWrapper}>
            <img src={eclipseImage} alt="eclipse" className={classes.eclipse} />
            <img src={serviceImage} alt="stars" className={classes.stars} />
          </div>
        </div>
      </div>
    </Page>
  );
};

export default Service;
